import React from 'react';
import PropTypes from 'prop-types';
import { getText } from 'src/utils/i18n';
import { Rating } from '@alifd/next';
import BuyersCount from './buyers-count';
import eventManager from '@alife/scc-event-manager/event-manager';
import './index.scss';

class ReviewStars extends React.PureComponent {
  static propTypes = {
    i18n: PropTypes.object,
  };

  state = {
    star: 0,
    count: 0,
    loaded: false,
  };

  componentDidMount() {
    eventManager.on('reviewStars:render', data => {
      const { score = {} } = data;
      const { reviewCount: count, averageScore: star } = score;

      this.setState({
        count,
        star,
        loaded: true,
      });
    });
  }

  render() {
    const { i18n, totalBuyers, style } = this.props;
    const { star, count, loaded } = this.state;

    if (!loaded) return null;

    const numberStar = Number(star);
    return (
      <div style={style}>
        {numberStar === 0 ? null : (
          <div
            className="transactions-content"
            style={{
              display: 'inline-block',
            }}
            onClick={() => {
              eventManager.trigger('changeDetailTab', 'detailDiscuss');
            }}
          >
            <div className="review-conclusion">
              <Rating size="small" defaultValue={numberStar} disabled />
              <span className="next-form-text-align review-value">{star}</span>
              <span className="next-form-text-align">
                {count} {getText(i18n, 'detail_discuss.reviews', 'Reviews')}
              </span>
            </div>
          </div>
        )}

        <BuyersCount
          buyers={totalBuyers}
          i18n={i18n}
          style={{
            paddingLeft: numberStar === 0 ? 0 : 20,
          }}
        />
      </div>
    );
  }
}

export default ReviewStars;
